export const environment = {
    production: true,
    env: 'staging',
    authUsername: "way-web-consumer",
    authPassword: "way-web-consumer-secret-test",
    wayadmin: "https://partnersstg.way.com/way-admin/v1/",
    wayauth: "https://partnersstg.way.com/way-auth/",
    wayConsumerUrl: 'https://partnersstg.way.com/way-consumer/',
};